import { useAuth } from "../auth/AuthContext";
import { AppLayout, MarketingLayout } from "../components/Layouts";
import { Loading } from "../components/ui";
import { HomePage } from "./HomePage";
import { LandingPage } from "./public/LandingPage";

/**
 * `/`: signed-in users get the app (HomePage in the app shell, unchanged); everyone else, including
 * visitors whose session check failed, gets the public landing page.
 */
export function RootPage() {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <main className="page-center">
        <Loading />
      </main>
    );
  }
  if (status === "authenticated") {
    return (
      <AppLayout>
        <HomePage />
      </AppLayout>
    );
  }
  return (
    <MarketingLayout>
      <LandingPage />
    </MarketingLayout>
  );
}
